import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import GrafikPDFDownload from '../GrafikPDFDownload';
import DownloadMaterialButton from '../DownloadMaterialButton';
import DownloadPdf from '../DownloadPdf';

import { PrimaryColor } from '../styles/colors';
import { mediaTablet } from '../styles/breakpoints';

const CTA_DESKTOP_SIZE = 325;
const CTA_SIZE = 250;

const Container = styled.article`
  width: ${CTA_DESKTOP_SIZE}px;
  height: ${CTA_DESKTOP_SIZE}px;

  transform: rotate(-3deg);

  ${mediaTablet} {
    width: ${CTA_SIZE}px;
    height: ${CTA_SIZE}px;
  }

  background-color: ${PrimaryColor};
  border-radius: 50%;

  padding: 40px;
  ${mediaTablet} {
    padding: 30px;
  }

  text-align: center;
`;

const DownloadMaterialButton1st = styled(DownloadMaterialButton)`
  margin-top: 15px;
  ${mediaTablet} {
    margin-top: 10px;
  }
`;

const DownloadMaterialButton2nd = styled(DownloadMaterialButton)`
  margin-top: 10px;
  ${mediaTablet} {
    margin-top: 0;
  }
`;

const CTA = ({ className }) => (
  <DownloadPdf className={className}>
    <Container>
      <GrafikPDFDownload insideCTA />
      <DownloadMaterialButton1st noicon />
      <br />
      <DownloadMaterialButton2nd nolabel />
    </Container>
  </DownloadPdf>
);

CTA.propTypes = {
  className: PropTypes.string,
};

CTA.defaultProps = {
  className: undefined,
};

export default CTA;



// WEBPACK FOOTER //
// ./src/components/PageHeader/CTA.js